import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { addUpdateContractEndpoint } from '../../../common/endpoints';

export const addUpdateContractData = createApi(addUpdateContractEndpoint, 'POST');

const AddContracts = createSlice({
  name: 'AddContracts',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addUpdateContractData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addUpdateContractData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addUpdateContractData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default AddContracts.reducer;